import React, { useContext } from 'react';
import PropTypes from "prop-types";
import { format } from "date-fns";
import { DateFormat } from "../../../../Helpers/DateTimeHelper";
import { intervalFromState } from "../../../../Helpers/IntervalHelper";
import { useReschedulerForm } from "./ReschedulerFormProvider";

const OccurrenceSummary = (props) => {
    const {
        occurrence,
        rescheduledOccurrence
    } = useReschedulerForm();

    const occurrenceInterval = intervalFromState(occurrence);

    const getIcon = () => {
        if (rescheduledOccurrence) {
            return (
                <i className="fa fa-check-square"
                   style={{ color: "green", padding: '0 1px' }}
                ></i>
            )
        } else if (rescheduledOccurrence === false) {
            return (
                <i className="fa fa-trash"
                   style={{ color: "green", padding: '0 1px' }}
                ></i>
            )
        } else if (occurrence.hasOwnProperty('is_available')
            && !occurrence.is_available
        ) {
            return <i className="fa fa-warning" style={{ color: "red" }}></i>
        } else {
            return (
                <i className="fa fa-check-square"
                   style={{ color: "green", padding: '0 1px' }}
                ></i>
            )
        }
    }

    const getClassName = () => {
        if (occurrence.hasOwnProperty('is_available')
            && !occurrence.is_available
        ) {
            return 'unavailable'
        }
        return '';
    }

    try {
        return (
            <div
                style={{marginBottom: "0.25rem"}}
                className={getClassName()}
            >
                {getIcon()}&nbsp;&nbsp;
                {format(occurrenceInterval.start, DateFormat.HUMAN_SLASHED_DATE)}&nbsp;
                @&nbsp;
                {format(occurrenceInterval.start, DateFormat.MYSQL_TIME)}
                -
                {format(occurrenceInterval.end, DateFormat.MYSQL_TIME)}&nbsp;
                ({format(occurrenceInterval.start, DateFormat.WEEKDAY)})
            </div>
        )
    } catch (error) {
        return <div style={{marginBottom: "0.25rem"}}>Date Error</div>
    }
};

OccurrenceSummary.propTypes = {
    //occurrence: PropTypes.object.isRequired
};

OccurrenceSummary.defaultProps = {};

export default OccurrenceSummary;
